import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormGroup,
  FormField,
  Dropdown,
  Button,
  Input,
  Icon
} from 'semantic-ui-react'

const CardTrainingKPISettingUX = (props: any) => {
    return(
      <div
        style={{padding: "10px"}}>
        <Form
          className="size small --override-disabled --grey"
          id="CardEmployeeSummaryWorkHourUX-Form-1">
          <FormGroup
            id="CardEmployeeSummaryWorkHourUX-FormGroup-2">
            <FormField
              id="CardTrainingKPISettingUX-FormField-41"
              width={2}>
              <label
                id="CardTrainingKPISettingUX-label-42"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Division" : "แผนก"}
              </label>
              <Dropdown
                fluid={true}
                id="CardTrainingKPISettingUX-Dropdown-46"
                name="division"
                onChange={props.onChangeFilter}
                options={props.divisionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.filter?.division ?? ""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-6"
              width={3}>
              <label
                id="CardEmployeeSummaryWorkHourUX-label-7"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Search employee" : "ค้นหาพนักงาน"}
              </label>
              <div
                id="CardTrainingKPISettingUX-div-45"
                style={{width: "100%"}}>
                {props.employeeSearchBox}
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-20"
              width={2}>
              <label
                id="CardEmployeeTimeAttendanceUX-label-28"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Position" : "ตำแหน่ง"}
              </label>
              <Dropdown
                clearable={true}
                fluid={true}
                id="CardEmployeeTimeAttendanceUX-Dropdown-27"
                onChange={props.onChangePosition}
                options={props.positionOptions}
                search={true}
                selection={true}
                style={{width: "100%"}}
                value={props.selectedPosition??""}>
              </Dropdown>
            </FormField>
            <FormField
              id="CardEmployeeSummaryWorkHourUX-FormField-12"
              style={{paddingRight: "0.5rem"}}>
              <label
                id="CardTrainingKPISettingUX-label-47">
                {"\u00A0"}
              </label>
              <div
                id="CardEmployeeSummaryWorkHourUX-div-13">
                {props.buttonSearch}
              </div>
            </FormField>
            <FormField
              id="CardTrainingKPISettingUX-FormField-64"
              width={1}>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-23"
              width={2}>
              <label
                id="CardTrainingKPISettingUX-label-48">
                {"\u00A0"}
              </label>
              <div
                id="CardTrainingKPISettingUX-div-49"
                style={{display: "flex", alignItems: "center"}}>
                
                <label
                  id="CardTrainingKPISettingUX-label-50"
                  style={{minWidth: "max-content", fontWeight: "bold", marginRight: "0.85em"}}>
                  {props.languageUX === "en" ? "Course (s)" : "หลักสูตร"}
                </label>
                <Input
                  disabled={!props.checkedIds?.length}
                  id="CardTrainingKPISettingUX-Input-51"
                  min="0"
                  name="course"
                  onChange={props.onChangeEmployeeTraining}
                  type="number"
                  value={props.employeeTraining?.course ?? ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardTrainingKPISettingUX-FormField-53"
              width={2}>
              <label
                id="CardTrainingKPISettingUX-label-55">
                {"\u00A0"}
              </label>
              <div
                id="CardTrainingKPISettingUX-div-58"
                style={{display: "flex", alignItems: "center"}}>
                
                <label
                  id="CardTrainingKPISettingUX-label-61"
                  style={{minWidth: "max-content", fontWeight: "bold", marginRight: "0.85em"}}>
                  {props.languageUX === "en" ? "Hour (s)" : "ชั่วโมง"}
                </label>
                <Input
                  disabled={!props.checkedIds?.length}
                  id="CardTrainingKPISettingUX-Input-63"
                  min="0"
                  name="hour"
                  onChange={props.onChangeEmployeeTraining}
                  type="number"
                  value={props.employeeTraining?.hour?? ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardTrainingKPISettingUX-FormField-54"
              width={2}>
              <label
                id="CardTrainingKPISettingUX-label-56">
                {"\u00A0"}
              </label>
              <div
                id="CardTrainingKPISettingUX-div-59"
                style={{display: "flex", alignItems: "center"}}>
                
                <label
                  id="CardTrainingKPISettingUX-label-60"
                  style={{minWidth: "max-content", fontWeight: "bold", marginRight: "0.85em"}}>
                  {props.languageUX === "en" ? "Score(s)" : "คะแนน"}
                </label>
                <Input
                  disabled={!props.checkedIds?.length}
                  id="CardTrainingKPISettingUX-Input-62"
                  min="0"
                  name="score"
                  onChange={props.onChangeEmployeeTraining}
                  type="number"
                  value={props.employeeTraining?.score?? ""}>
                </Input>
              </div>
            </FormField>
            <FormField
              id="CardEmployeeTimeAttendanceUX-FormField-25">
              <label
                id="CardTrainingKPISettingUX-label-52">
                {"\u00A0"}
              </label>
              <Button
                color="blue"
                disabled={!props.checkedIds?.length}
                id="CardEmployeeTimeAttendanceUX-Button-35"
                onClick={props.onSaveToEmployee}
                size="small"
                style={{minWidth: "max-content"}}>
                {props.languageUX === "en" ? "Save to Selected Employee" : "บันทึกไปยังพนักงานที่เลือก"}
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <div
          className="ui form small size"
          id="CardTrainingKPISettingUX-div-65"
          style={{margin: "1.25rem 0 0.5rem 3rem"}}>
          
          <FormGroup
            id="CardTrainingKPISettingUX-FormGroup-69"
            inline={true}
            style={{ alignItems: "flex-start" }}>
            <FormField
              id="CardTrainingKPISettingUX-FormField-70"
              inline={true}>
              <Button
                basic={!props.isAddEmployeeMode}
                color="blue"
                icon={true}
                id="CardTrainingKPISettingUX-Button-73"
                onClick={props.onClickAddEmployee}
                size="small">
                <Icon
                  id="CardTrainingKPISettingUX-Icon-74"
                  name="user plus">
                </Icon>
                <label
                  id="CardTrainingKPISettingUX-label-75"
                  style={{margin: "0 2.5rem"}}>
                  {props.languageUX === "en" ? "Employee" : "พนักงาน"}
                </label>
              </Button>
            </FormField>
            <FormField
              inline={true}>
              <div>
                {props.addRadioButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardEmployeeSummaryWorkHourUX-div-15"
          style={{width: "100%"}}>
          {props.table}
        </div>
        <div
          id="CardTrainingKPISettingUX-div-78"
          style={{display: "flex", justifyContent: "flex-end", marginTop: "1rem"}}>
          
          <div
            id="CardTrainingKPISettingUX-div-79">
            {props.buttonSave}
          </div>
        </div>
      </div>
    )
}


export default CardTrainingKPISettingUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Mon Sep 01 2025 15:56:50 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "size small --override-disabled --grey"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormGroup-2"
        },
        "inline": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "label",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหาพนักงาน",
          "valueEN": "Search employee"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-label-7"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0.5rem\"}"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-13"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.table"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeSummaryWorkHourUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-20"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 25,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-FormField-25"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 27,
      "name": "Dropdown",
      "parent": 20,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Dropdown-27"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePosition"
        },
        "options": {
          "type": "code",
          "value": "props.positionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedPosition??\"\""
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 20,
      "props": {
        "children": {
          "type": "value",
          "value": "ตำแหน่ง",
          "valueEN": "Position"
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Button",
      "parent": 25,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกไปยังพนักงานที่เลือก",
          "valueEN": "Save to Selected Employee"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "!props.checkedIds?.length"
        },
        "icon": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardEmployeeTimeAttendanceUX-Button-35"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveToEmployee"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "Division"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-42"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.employeeSearchBox"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "Dropdown",
      "parent": 41,
      "props": {
        "clearable": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Dropdown-46"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filter?.division ?? \"\""
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-47"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-48"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "หลักสูตร",
          "valueEN": "Course (s)"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-50"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"bold\", marginRight: \"0.85em\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "Input",
      "parent": 49,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.checkedIds?.length"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Input-51"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "course"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEmployeeTraining"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.employeeTraining?.course ?? \"\""
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "label",
      "parent": 25,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-52"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-55"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "\"\\u00A0\""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "label",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "คะแนน",
          "valueEN": "Score(s)"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-60"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"bold\", marginRight: \"0.85em\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ชั่วโมง",
          "valueEN": "Hour (s)"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\", fontWeight: \"bold\", marginRight: \"0.85em\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "Input",
      "parent": 59,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.checkedIds?.length"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Input-62"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "score"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEmployeeTraining"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.employeeTraining?.score?? \"\""
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Input",
      "parent": 58,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.checkedIds?.length"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Input-63"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "name": {
          "type": "value",
          "value": "hour"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEmployeeTraining"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.employeeTraining?.hour?? \"\""
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "FormField",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormField-64"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "1"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form small size"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"1.25rem 0 0.5rem 3rem\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormGroup",
      "parent": 65,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormGroup-69"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ alignItems: \"flex-start\" }"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "FormField",
      "parent": 69,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-FormField-70"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Button",
      "parent": 70,
      "props": {
        "basic": {
          "type": "code",
          "value": "!props.isAddEmployeeMode"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Button-73"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAddEmployee"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Icon",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-Icon-74"
        },
        "name": {
          "type": "value",
          "value": "user plus"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "label",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "พนักงาน",
          "valueEN": "Employee"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-label-75"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 2.5rem\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-78"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 78,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardTrainingKPISettingUX-div-79"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 83,
      "name": "FormField",
      "parent": 69,
      "props": {
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 83,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addRadioButton"
        }
      },
      "seq": 84,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardTrainingKPISettingUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
